import { TableCell, Tooltip } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MoneyIcon from '@material-ui/icons/Money';
import React, { Fragment, useEffect } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import DataTable from '../../../../components/DataTable_v2/DataTable';
import usePagination from '../../../../hooks/usePagination';

const TransactionsList = ({ data, loading, count, refresh }) => {
  const { page, onChangePage, rowsPerPage, onChangeRowsPerPage } = usePagination({});
  const intl = useIntl();
  const history = useHistory();

  useEffect(() => {
    refresh(page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <DataTable
      loading={loading}
      pagination
      page={page}
      count={count || 0}
      rowsPerPage={rowsPerPage}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      data={data}
      onRowClick={(row) => {
        history.push(`/transaction/${row.ID}`);
      }}
      columns={[
        {
          id: 'closed_on',
          label: <FormattedMessage id={'transaction.closedOn'} />,
        },
        {
          id: 'document_no',
          label: <FormattedMessage id={'transaction.documentNo'} />,
        },
        {
          id: 'closed_by',
          label: <FormattedMessage id={'transaction.closedBy'} />,
        },
        {
          id: 'netAmount',
          label: <FormattedMessage id={'closure.netAmount'} />,
          align: 'right',
        },
        {
          id: 'taxAmount',
          label: <FormattedMessage id={'closure.taxAmount'} />,
          align: 'right',
        },
        {
          id: 'grossAmount',
          label: <FormattedMessage id={'closure.grossAmount'} />,
          align: 'right',
        },
        {
          id: 'payments',
          label: <FormattedMessage id={'transaction.payments'} />,
          align: 'right',
        },
      ]}
      template={({ document_no, modified_on, name, taxAmount, grossAmount, payments }) => {
        const types = {
          CARD: (
            <Tooltip title={intl.formatMessage({ id: 'payment.card' })}>
              <CreditCardIcon />
            </Tooltip>
          ),
          CASH: (
            <Tooltip title={intl.formatMessage({ id: 'payment.cash' })}>
              <MoneyIcon />
            </Tooltip>
          ),
        };

        return (
          <>
            <TableCell>
              <FormattedDate value={modified_on} /> <FormattedTime value={modified_on} />
            </TableCell>
            <TableCell>{document_no}</TableCell>
            <TableCell>{name}</TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <FormattedNumber value={grossAmount - taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <FormattedNumber value={taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <FormattedNumber value={grossAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              {payments?.map((payment, index) => {
                return <Fragment key={index}>{types?.[payment]}</Fragment>;
              })}
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <ArrowForwardIcon />
            </TableCell>
          </>
        );
      }}
    />
  );
};

export default TransactionsList;
